/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["tg",[["AM","PM"]],u,[["Я","Д","С","Ч","П","Ҷ","Ш"],["Яшб","Дшб","Сшб","Чшб","Пшб","Ҷмъ","Шнб"],["Якшанбе","Душанбе","Сешанбе","Чоршанбе","Панҷшанбе","Ҷумъа","Шанбе"],["Яшб","Дшб","Сшб","Чшб","Пшб","Ҷмъ","Шнб"]],u,[["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],["Январ","Феврал","Март","Апрел","Май","Июн","Июл","Август","Сентябр","Октябр","Ноябр","Декабр"]],u,[["ПеМ","ПаМ"],u,["Пеш аз милод","Пас аз милод"]],1,[6,0],["dd/MM/yy","dd MMM y","dd MMMM y","EEEE, dd MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","#,##0.00 ¤","#E0"],"TJS","сом.","Сомонии Тоҷикистон",{"JPY":["JP¥","¥"],"TJS":["сом."]},"ltr", plural];
